import React from "react";

const Paragraph = ({ text }) => {
  if (!text) return null;
  return <p className="body pr2 m0 mb5">{text}</p>;
};

export { Paragraph };
